<template>
    <div>
        <b-table :data="categories" v-if="categories !== null" focusable :selected.sync="activeItem">
            <template slot-scope="props">
                <b-table-column label="Category">
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column label="Created On">
                    {{ props.row.createdAt }}
                </b-table-column>
            </template>
        </b-table>

        <category-editor></category-editor>
    </div>
</template>

<script>
import CategoryEditor from './CategoryEditor';
import BTable from 'buefy/src/components/table/Table';
import BTableColumn from 'buefy/src/components/table/TableColumn';

export default {
  components: {
    BTableColumn,
    BTable,
    CategoryEditor,
  },

  name: 'admin-categories',

  data() {
    return {
      createNew: false,
    };
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      this.$store.dispatch('adminCategories/load');
    },

    saveCategory() {
      this.$refs.new.$validator.validateAll().then((valid) => {
        if (valid) {
          return this.$store
            .dispatch('adminCategories/save', { name: this.$refs.new.name })
            .then(() => this.$store.dispatch('adminCategories/load'))
            .then(() => (this.createNew = false));
        }
      });
    },
  },

  computed: {
    categories() {
      return this.$store.state.adminCategories.categories;
    },

    loading() {
      return this.$store.state.adminCategories.loading;
    },

    activeItem: {
      get() {
        return this.$store.state.adminCategories.active;
      },

      set(itm) {
        return this.$store.commit('adminCategories/setActive', itm);
      },
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminCategories.vue